<div class="content">
  @if (record.symbol; as symbol) {
    <rt-symbol [symbol]="symbol" margin-right-small-x />
  }
  <div layout-vertical>
    <rt-heading variant="heading">
      <span class="template-name">{{ record.name }}</span>
    </rt-heading>
    <div
      prosemirrorBasicConfig
      [prosemirrorRender]="
        !record.descriptionJson || record.descriptionJson.doc
          ? record.descriptionJson
          : { doc: record.descriptionJson }
      "
      [prosemirrorRenderConfig]="ProsemirrorBasicConfig"
      class="description-content"
    ></div>
  </div>
  <rt-admins-avatars [admins]="assignedUsers()" [stacked]="true" margin-left-auto />
</div>
